import { useMemo } from 'react'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const usePhotos = () => {
  const { photos, totalPhotos } = useShallowEqualSelector(
    ({ photoViewerReducer: { photos, totalPhotos } }) => ({
      photos,
      totalPhotos,
    })
  )

  return useMemo(() => {
    return {
      photos,
      totalPhotos: totalPhotos,
    }
  }, [photos, totalPhotos])
}
